import type { ReactNode } from "react";
import { brandColors as colors } from "@/lib/palette";
import { fonts } from "@/lib/fonts";

type MetaPillProps = {
  icon?: ReactNode;
  children: ReactNode;
  tone?: "neutral" | "accent" | "warm";
  accentColor?: string;
};

export default function MetaPill({
  icon,
  children,
  tone = "neutral",
  accentColor,
}: MetaPillProps) {
  const palette =
    tone === "accent"
      ? { bg: `${accentColor ?? colors.berryRose}14`, fg: accentColor ?? colors.berryRose }
      : tone === "warm"
        ? { bg: `${colors.tan}1a`, fg: colors.tanDeep }
        : { bg: `${colors.navy}0d`, fg: colors.navy };

  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[11px] tracking-[0.12em] uppercase"
      style={{
        fontFamily: fonts.body,
        fontWeight: 700,
        backgroundColor: palette.bg,
        color: palette.fg,
      }}
    >
      {icon}
      {children}
    </span>
  );
}
